import { createRouter, createWebHistory } from "vue-router";
import AuthGuard from "@/middleware/auth";
import DashBoard from "@/views/dashboard";
import Profiles from "@/views/profiles";
import Messages from "@/views/messages";
import NotFound from "@/views/not-found";

const req = require.context(".", true, /\.js$/);

const modules = [];

req.keys().forEach((fileName) => {
  if (fileName === "./index.js") return;
  let fileItems = req(fileName);
  modules.push(...fileItems.default);
});

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...modules,
    { path: "/", name: "DashBoard", component: DashBoard, beforeEach: AuthGuard },
    { path: "/view/profiles", name: "UserProfile", component: Profiles, beforeEach: AuthGuard },
    { path: "/messages", name: "Messages", component: Messages, beforeEach: AuthGuard },
    { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound }
  ]
});

export default router;
